import { Alchemy, Network } from 'alchemy-sdk';

// Configure Alchemy SDK based on environment
const config = {
  apiKey: process.env.NEXT_PUBLIC_ALCHEMY_API_KEY,
  network:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? Network.ETH_MAINNET
      : Network.ETH_SEPOLIA,
};

/**
 * Interface for NFT metadata retrieval parameters
 * @interface IGetNFTMetadata
 * @property {string} contractAddress - The smart contract address of the NFT collection
 * @property {string} tokenId - The unique identifier of the specific NFT token
 */
interface IGetNFTMetadata {
  contractAddress: string;
  tokenId: string;
}

// Initialize Alchemy SDK instance
const alchemy = new Alchemy(config);

/**
 * Retrieves metadata for a specific NFT using Alchemy SDK
 * @async
 * @param {IGetNFTMetadata} params - The parameters for fetching NFT metadata
 * @param {string} params.contractAddress - The smart contract address of the NFT collection
 * @param {string} params.tokenId - The unique identifier of the specific NFT token
 * @returns {Promise<{data: any}>} The NFT metadata wrapped in a data object
 * @throws Will throw an error if the API request fails
 */
export const getNFTMetadata = async ({
  contractAddress,
  tokenId,
}: IGetNFTMetadata) => {
  const data = await alchemy.nft.getNftMetadata(contractAddress, tokenId, {});

  return {
    data,
  };
};
